'use client';

import React from 'react';
import { Grid, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PrimaryNav from './PrimaryNav';
import SocialNav from './SocialNav';
import SecondaryNav from './SecondaryNav';
import ScrollToTop from './ScrollToTop';
import { useStyles } from './style';

/**
 * @name EirFooterContainer
 * @description Displays footer of the application
 * @param {*} param0 - Destructured object
 * @param {object} param0.cmsFooterData -Footer data from strapi
 * @returns {JSX.Element} ReactElement
 */
const EirFooterContainer = ({ cmsFooterData }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Container maxWidth='lg' sx={styles.containerStyle}>
      <Grid container sx={{ mt: 0 }} spacing={3}>
        <Grid item xs={12}>
          <ScrollToTop style={styles.scrollTop} />
        </Grid>
        {/* primary navs */}
        <Grid item xs={12}>
          <PrimaryNav data={cmsFooterData?.attributes?.PrimaryNav} />
        </Grid>
        {/* social links */}
        <Grid item xs={12}>
          <SocialNav data={cmsFooterData?.attributes} />
        </Grid>
        {/* secondary navs */}
        <Grid item container justifyContent='center' xs={12} spacing={2}>
          <SecondaryNav data={cmsFooterData?.attributes?.SecondaryNav} />
        </Grid>

        {/* disclaimer */}
        <Grid item xs={12}>
          <Typography
            variant='subtitle1'
            dangerouslySetInnerHTML={{ __html: cmsFooterData?.attributes?.Disclaimer }}
            sx={styles.disclaimerStyle}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default EirFooterContainer;
